// Generated from site/assets/js/en.js by scripts/import-prototype-catalog.mjs. Do not edit:
// add new strings to the area files next to this one instead.
export const prototypeEn: Readonly<Record<string, string>> = {
  "،": ",",
  "، حجز": ", booking",
  "، محسوبة بنسبة الفترة": ", prorated by period",
  "، وحصّل": ", and collect",
  "12 سبتمبر": "12 September",
  "18 – 20 نوفمبر": "18 – 20 November",
  "2 أكتوبر · 8:20 م": "2 October · 8:20 PM",
  "25 ديسمبر – 2 يناير": "25 December – 2 January",
  "28 سبتمبر": "28 September",
  "3 أكتوبر · 10:12 ص": "3 October · 10:12 AM",
  "3 أكتوبر · 4:30 م": "3 October · 4:30 PM",
  "3 أكتوبر · 7:05 م": "3 October · 7:05 PM",
  "30 سبتمبر · 9:00 م": "30 September · 9:00 PM",
  "ا": "A",
  "آخر دخول": "Last login",
  "آخر سيارة متاحة": "Last car available",
  "آخر قراءة مسجلة:": "Last recorded reading:",
  "ابدأ الاستلام": "Start check-in",
  "ابدأ التسليم": "Start handover",
  "ابدأ الرحلة": "Start the trip",
  "أبريل": "April",
  "أبيض لؤلؤي": "Pearl white",
  "أتاح": "Enabled",
  "إجازة نهاية العام": "Year-end holiday",
  "إجمالي الإيرادات": "Total revenue",
  "احجز": "Book",
  "احجز الآن": "Book now",
  "احجز الآن وادفع العربون فقط، والباقي عند الاستلام.": "Book now and pay only the deposit, the rest at pickup.",
  "احجز رحلتك": "Book your trip",
  "احجز مع الباقة": "Book with the package",
  "أحضر البطاقة والرخصة الأصليتين. نطابقها ونسجّل العداد ونسبة البطارية ثم تنطلق.": "Bring your original ID card and licence. We verify them, log the odometer and battery level, and you're on your way.",
  "أحمد البلوشي": "Ahmed Al Balushi",
  "أحمد الرواحي": "Ahmed Al Rawahi",
  "أحمر": "Red",
  "اختر الحجز الذي سيستلم سيارته": "Choose the booking that's picking up",
  "اختر السيارة": "Choose a car",
  "اختر السيارة العائدة": "Choose the returning car",
  "اختر السيارة والإضافات": "Choose your car and extras",
  "اختر الفترة ونوع التقرير، ثم صدّره أو اطبعه": "Choose the period and report type, then export or print",
  "اختر دوراً لتعديل صلاحياته": "Choose a role to edit its permissions",
  "اختر سبب الإلغاء أولاً": "Choose a cancellation reason first",
  "اختر سيارة": "Choose a car",
  "اختر سيارة متاحة للمتابعة": "Choose an available car to continue",
  "اختر قسماً، اكتب النص بالعربية والإنجليزية، وشاهد الموقع يتغير مباشرة": "Pick a section, write in Arabic and English, and watch the site change live",
  "اختر يوماً واحداً على الأقل": "Pick at least one day",
  "اختياري. تُجهّز في السيارة قبل الاستلام.": "Optional. Prepared in the car before pickup.",
  "أخرى": "Other",
  "أخفى": "hid",
  "أُخفي القسم من الموقع": "Section hidden from the site",
  "أداء السيارات هذا الشهر": "Fleet performance this month",
  "إدارة الأسطول": "Fleet management",
  "أدخل الاسم والهاتف والرخصة": "Enter name, phone and licence",
  "أدخل العداد وافحص الإضافات": "Enter the odometer and check the add-ons",
  "أدخل بيانات البطاقة": "Enter card details",
  "أدخل رقم الحجز والهاتف": "Enter your booking number and phone",
  "ادفع": "Pay",
  "ادفع العربون": "Pay deposit",
  "ادفع العربون الآن والباقي عند الاستلام، أو ادفع المبلغ كاملاً.": "Pay the deposit now and the rest at pickup, or pay in full.",
  "ارتفاع الجبل الأخضر. تصعده بهدوء تام، بلا صوت محرك.": "Jebel Akhdar's elevation. Climb it in complete calm, with no engine noise.",
  "أرسلت الطلب": "Request sent",
  "أرسلنا العقد إلى واتساب": "We sent the contract to WhatsApp",
  "أرسلنا طلبك، سيصلك الرد على واتساب": "We've sent your request. You'll get a reply on WhatsApp",
  "أرصدة الزبائن": "Customer credit",
  "أرصدة الزبائن القائمة": "Outstanding customer credit",
  "ارفع مستنداتك وادفع": "Upload your documents and pay",
  "أزرق": "Blue",
  "أسبوعي": "Weekly",
  "استخدام في الحجز": "Use for booking",
  "استخدمه في هذا الحجز": "Use it on this booking",
  "استرجاع الأصل": "Restore original",
  "استرجع النص الأصلي": "restored the original text",
  "استغرق التسليم 9 دقائق": "Handover took 9 minutes",
  "استلام": "Pickup",
  "استلام سيارة": "Check in car",
  "استلام سيارة من الزبون": "Check in a car from a customer",
  "استلام من الزبائن": "Returns from customers",
  "استلام من الزبون": "Check in from customer",
  "استلم": "Check in",
  "استلم العقد وانطلق": "Collect your contract and go",
  "استلم سيارتك مشحونة من بركة الموز، ويصلك عقد الإيجار على واتساب فور الدفع.": "Pick up your car fully charged in Birkat Al Mouz, and your rental contract arrives on WhatsApp as soon as you pay.",
  "استلم Model Y (4821 AM) من حجز #1039 — 212 كم، 15.6 kWh، نظيفة": "Checked in Model Y (4821 AM) from booking #1039 — 212 km, 15.6 kWh, clean",
  "استلمت": "Received",
  "استهلاك الطاقة": "Energy use",
  "إسحاق الغماري": "Ishaq Al Ghummari",
  "اسحب الملف هنا أو اضغط للرفع": "Drag the file here or click to upload",
  "أسرع تسارع وثبات أعلى على منعطفات الجبل.": "Quicker acceleration and more grip on mountain bends.",
  "أسعار التأجير الأساسية": "Base rental rates",
  "أسعار نهاية الأسبوع": "Weekend pricing",
  "أسعار نهاية الأسبوع تظهر الآن في موقع الحجز": "Weekend prices are now live on the booking site",
  "اسم الدور": "Role name",
  "اسم الزبون": "Customer name",
  "اسم المستخدم": "Username",
  "أسود": "Black",
  "اشترط الدفع الكامل لـ": "required full payment for",
  "إصدار الفواتير وطباعتها": "Issue and print invoices",
  "اصعد الجبل الأخضر": "Drive up Jebel Akhdar",
  "أضاف حجزاً حضورياً": "added a walk-in booking",
  "أضاف حجزاً حضورياً #1048 للزبونة ليلى التوبية": "Added walk-in booking #1048 for customer Laila Al Toubi",
  "أضاف خدمة": "Added a service",
  "أضاف رصيداً": "Added credit",
  "إضافات": "Extras",
  "إضافة": "Add",
  "إضافة الرصيد": "Add credit",
  "إضافة رصيد يدوياً": "Add credit manually",
  "إضافة موظف": "Add staff member",
  "اضغط على المخطط لتحديد موضع أي خدش جديد.": "Tap the diagram to mark the position of any new scratch.",
  "اضغط على اليوم لإغلاقه": "Tap a day to close it",
  "اضغط على أي حجز للتعديل أو الإلغاء": "Tap any booking to edit or cancel",
  "أضف ما تحتاجه للرحلة": "Add what you need for the trip",
  "أضفنا": "We added",
  "أضفنا باقة الكشتة إلى حجزك": "We've added the outing package to your booking",
  "أضيف": "Added",
  "أضيف الرصيد": "Credit added",
  "أضيفت الخدمة وتظهر الآن في الحجز": "Service added and now shows on the booking",
  "اطلب التحويل إلى رصيد": "Request conversion to credit",
  "إظهار القسم": "Show section",
  "أظهر": "showed",
  "اعتماد": "Approve",
  "اعتماد الرصيد": "Approve credit",
  "اعتماد طلب الزبون": "Approve customer request",
  "اعتُمد الرصيد": "Credit approved",
  "اعرض الحجز": "View booking",
  "أغسطس": "August",
  "إغلاق": "Close",
  "إغلاق القائمة": "Close menu",
  "أغلق": "Close",
  "افتح الموقع": "Open site",
  "اقرأها قبل الدفع. ستجدها أيضاً في العقد المرسل على واتساب.": "Read these before paying. You'll also find them in the contract sent on WhatsApp.",
  "أقسام الصفحة الرئيسية": "Homepage sections",
  "أقل": "Less",
  "أقل من 3 أيام على موعد الاستلام، حسب سياسة الإيجار لا يُلغى ولا يُسترد.": "Less than 3 days before pickup. Under the rental policy, it can't be cancelled or refunded.",
  "أقل من 3 أيام).": "less than 3 days).",
  "أكتوبر": "October",
  "أكثر": "More",
  "أكمل الحقول وارفع المستندين": "Complete the fields and upload both documents",
  "أكمل الخطوات الثلاث": "Complete the three steps",
  "أكواد الخصم": "Discount codes",
  "الآن": "Now",
  "الآن، ولا شيء عليك عند الاستلام.": "now, and nothing at pickup.",
  "الإثنين": "Monday",
  "الإجراءات": "Actions",
  "الإجمالي": "Total",
  "الأحد": "Sunday",
  "الأخضر": "Green",
  "الإدارة": "Management",
  "الأدوار": "Roles",
  "الأدوار والصلاحيات": "Roles and permissions",
  "الأرباح": "Profit",
  "الأرباح والتقارير": "Earnings and reports",
  "الأربعاء": "Wednesday",
  "الأردن": "Jordan",
  "الأرصدة": "Credit",
  "الأرصدة والقسائم": "Credit and vouchers",
  "الاستخدام": "Usage",
  "الاستلام": "Pickup",
  "الأسطول": "Fleet",
  "الأسعار والإعدادات": "Pricing and settings",
  "الاسم": "Name",
  "الاسم الكامل كما في البطاقة": "Full name as on ID card",
  "الإضافات": "Extras",
  "الأضرار": "Damage",
  "الإطارات (كل": "Tyres (every",
  "الأقرب": "Nearest",
  "الأقوى": "Most powerful",
  "الإمارات": "UAE",
  "الأمام": "Front",
  "الأنسب للجبل": "Best for the mountain",
  "الأوفر": "Best value",
  "الأيام": "Days",
  "الإيجار 150 ر.ع والراتب 200 ر.ع شهرياً": "Rent OMR 150 and salaries OMR 200 per month",
  "الإيراد": "Revenue",
  "الإيرادات": "Revenue",
  "الإيرادات اليومية": "Daily revenue",
  "الإيرادات: تأجير وإضافات": "Revenue: rentals and add-ons",
  "الباقي": "Balance",
  "البترول": "Fuel",
  "البحرين": "Bahrain",
  "البطارية": "Battery",
  "البطارية المستهلكة": "Battery used",
  "البطاقة الشخصية": "ID card",
  "البطاقة والرخصة، ثم العربون أو المبلغ كاملاً.": "ID card and licence, then the deposit or the full amount.",
  "البند": "Item",
  "التأجير": "Rentals",
  "التأخير": "Late return",
  "التاريخ": "Date",
  "التالي": "Next",
  "التذييل والتواصل": "Footer & contact",
  "التسعير العادي": "Standard pricing",
  "التسليم": "Handover",
  "التصدير غير مفعّل لدورك": "Export is not enabled for your role",
  "التفاصيل": "Details",
  "التقارير والفواتير": "Reports and invoices",
  "الثلاثاء": "Tuesday",
  "الجانب الأيسر": "Left side",
  "الجانب الأيمن": "Right side",
  "الجزائر": "Algeria",
  "الجمعة": "Friday",
  "الجمعة · 10:00 ص": "Friday · 10:00 AM",
  "الجمعة · 10:00 ص · بركة الموز": "Friday · 10:00 AM · Birkat Al Mouz",
  "الجمعة · 11:20 ص · سيح قطنة": "Friday · 11:20 AM · Saiq",
  "الجمعة · 8:00 م": "Friday · 8:00 PM",
  "الجمعة 10:00 ص": "Friday 10:00 AM",
  "الجمعة 9 أكتوبر": "Friday 9 October",
  "الحالة": "Status",
  "الحجز": "Booking",
  "الحجز ليوم": "Booking for",
  "الحجز مغلق": "Booking closed",
  "الحجز مغلق في هذا اليوم، اختر يوماً آخر.": "Bookings are closed on this day. Choose another day.",
  "الحجوزات": "Bookings",
  "الحسابات": "Accounts",
  "الخدمات الإضافية": "Extra services",
  "الخدمة": "Service",
  "الخصم": "Discount",
  "الخصومات": "Discounts",
  "الخطوة": "Step",
  "الخلف": "Rear",
  "الخميس": "Thursday",
  "الخميس · 9:40 م": "Thursday · 9:40 PM",
  "الخميس · 9:41 م": "Thursday · 9:41 PM",
  "الدفع": "Payment",
  "الدفع كاملاً عند الحجز": "Full payment at booking",
  "الدور": "Role",
  "الرئيسية": "Home",
  "الرحلة": "Trip",
  "الرخصة": "Licence",
  "الرقم 1": "Figure 1",
  "الرقم 2": "Figure 2",
  "الرقم 3": "Figure 3",
  "الرقم 4": "Figure 4",
  "الرقم المدني": "Civil ID number",
  "الرقم المدني:": "Civil ID:",
  "الزبون": "Customer",
  "الزبون يدفع": "Customer pays",
  "الزبون يدفع المبلغ كاملاً عند الحجز": "Customer pays the full amount at booking",
  "الزر": "Button",
  "السابقة": "Previous",
  "السبب": "Reason",
  "السبب:": "Reason:",
  "السبت": "Saturday",
  "السعر": "Price",
  "السعر محسوب تلقائياً من تسعيرة المالك ولا يمكن تعديله من هذا الحساب.": "The price is calculated automatically from the owner's pricing and can't be edited from this account.",
  "السعر من تسعيرة المالك، غير قابل للتعديل": "Price set by the owner's pricing, can't be edited",
  "السعر يختلف بين الفترة النهارية واليوم الكامل.": "Price differs between the daytime period and a full day.",
  "السعودية": "Saudi Arabia",
  "السقف": "Roof",
  "السودان": "Sudan",
  "السيارات": "Cars",
  "السيارة": "Car",
  "السيارة غير متاحة في هذا الموعد": "The car is not available at this time",
  "السيارة مشحونة": "Car is charged",
  "الشحن": "Charge",
  "الشحن مشمول، وأعد السيارة بأي نسبة بطارية.": "Charging is included. Return the car at any battery level.",
  "الشحنات": "Charges",
  "الشروط": "Terms",
  "الشروط تنص على تسليم السيارة بشحن 85% على الأقل": "Terms require the car to be returned with at least 85% charge",
  "الشهر الماضي": "Last month",
  "الشواء والطبخ والتخييم": "BBQ, cooking and camping",
  "الصافي": "Net",
  "الصفحة الرئيسية": "Homepage",
  "الصور من": "Photos by",
  "الصين": "China",
  "الطاقة": "Energy",
  "الطاقة المستهلكة": "Energy used",
  "الطراز": "Model",
  "العداد": "Odometer",
  "العداد والبطارية عند الخروج": "Odometer and battery at departure",
  "العداد والبطارية عند العودة": "Odometer and battery on return",
  "العراق": "Iraq",
  "العربون": "Deposit",
  "العربون الآن": "Deposit now",
  "العربون متاح لهذه السيارة": "Deposit is available for this car",
  "العقد يصلك فوراً": "Your contract arrives instantly",
  "العمر والرخصة": "Age and licence",
  "العمليات": "Operations",
  "العنوان": "Headline",
  "العنوان · نهاري": "Headline · daytime",
  "العنوان · يوم كامل (ليلي)": "Headline · full day (night)",
  "العنوان الصغير": "Eyebrow",
  "العودة للرئيسية": "Back to home",
  "العيد الوطني": "National Day",
  "إلغاء حجز نهائياً (عدم حضور)": "Cancel booking permanently (no-show)",
  "إلغاء نهائي": "Cancel permanently",
  "إلغاء نهائي بدون رصيد": "Cancel permanently without credit",
  "الغروب من سيح قطنة.": "Sunset from Saiq.",
  "ألغى الحجز رقم": "cancelled booking no.",
  "ألغى الحجز رقم #1040 — السبب: طلب الزبون": "Cancelled booking #1040 — reason: customer request",
  "الفاتورة": "Invoice",
  "الفترة": "Period",
  "الفحص الدوري": "Scheduled service",
  "الفحص الدوري (كل": "Routine service (every",
  "الفريق والصلاحيات": "Team and permissions",
  "الفلبين": "Philippines",
  "القائمة": "Menu",
  "القراءة أقل من آخر قراءة مسجلة": "Reading is lower than the last recorded reading",
  "القراءة أقل من عداد الخروج": "Reading is below the departure odometer",
  "الكراسي علينا، والقهوة عليك.": "Chairs are on us, coffee is on you.",
  "الكفاءة": "Efficiency",
  "الكل": "All",
  "الكمية": "Quantity",
  "الكود": "Code",
  "الكود غير صالح لهذا التاريخ": "This code isn't valid for this date",
  "الكويت": "Kuwait",
  "الكيلومترات": "Kilometres",
  "اللوحة": "Plate",
  "المالك": "Owner",
  "ألمانيا": "Germany",
  "المبلغ": "Amount",
  "المبلغ (ر.ع)": "Amount (OMR)",
  "المبلغ كاملاً": "Full amount",
  "المتاح في": "Available on",
  "المتبقي": "Remaining",
  "المتبقي على الزبون": "Balance due from customer",
  "المتبقي عند الاستلام": "Balance due at pickup",
  "المحصّل": "Collected",
  "المحطة 1": "Stop 1",
  "المحطة 2": "Stop 2",
  "المحطة 3": "Stop 3",
  "المحطة 4": "Stop 4",
  "المحطة 5": "Stop 5",
  "المدفوع": "Paid",
  "المسافة": "Distance",
  "المسافة المقطوعة": "Distance driven",
  "المطلوب الآن": "Due now",
  "المغرب": "Morocco",
  "المملكة المتحدة": "United Kingdom",
  "المواسم والإجازات الرسمية": "Seasons and public holidays",
  "الموظف": "Staff member",
  "الموظفون": "Staff",
  "الموعد": "Time",
  "الموقع": "Location",
  "النسبة": "Rate",
  "النص": "Text",
  "النص الأصلي": "Original text",
  "النص التعريفي · نهاري": "Intro text · daytime",
  "النص التعريفي · يوم كامل": "Intro text · full day",
  "النص الجانبي": "Side text",
  "النظافة والخدوش": "Cleanliness and scratches",
  "النوع": "Type",
  "الهاتف": "Phone",
  "الهند": "India",
  "الواجهة الأمامية": "Front",
  "الواجهة الرئيسية": "Hero",
  "الوحدة 1": "Unit 1",
  "الوحدة 2": "Unit 2",
  "الوحدة 3": "Unit 3",
  "الوحدة 4": "Unit 4",
  "الوصف 1": "Caption 1",
  "الوصف 2": "Caption 2",
  "الوصف 3": "Caption 3",
  "الوصف 4": "Caption 4",
  "الولايات المتحدة / كندا": "United States / Canada",
  "إلى": "to",
  "إلى الجبل والعودة بشحنة واحدة": "to the mountain and back on a single charge",
  "إلى الشحن": "To charging",
  "إلى رصيد": "to credit",
  "إلى رصيد بقيمة": "to credit worth",
  "اليمن": "Yemen",
  "اليوم": "Today",
  "اليوم 8:02 ص": "Today 8:02 AM",
  "اليوم 9:12 ص": "Today 9:12 AM",
  "أمس 6:15 م": "Yesterday 6:15 PM",
  "أمس 9:40 م": "Yesterday 9:40 PM",
  "أنت فوق، على 2,000 م": "You're up top, at 2,000 m",
  "انتهت الرحلة": "Trip ended",
  "أنشأ": "created",
  "أنشأ حساباً للموظف": "Created a staff account for",
  "أُنشئ في": "Created on",
  "أنشأ كود الخصم": "Created discount code",
  "أنشأ كود الخصم JABAL10 بنسبة 10% (1 – 31 أكتوبر)": "created discount code JABAL10 at 10% (1 – 31 October)",
  "إنشاء الحجز": "Create booking",
  "إنشاء الحساب": "Create account",
  "إنشاء الكود": "Create code",
  "إنهاء الاستلام": "Complete check-in",
  "أهلاً سالم، تم تأكيد حجزك": "Hello Salem, your booking is confirmed",
  "أو أنشئ دوراً جديداً مثل «مشرف مسائي» أو «محاسب»، وحدد الصفحات والإجراءات المسموحة له.": "Or create a new role such as “Evening supervisor” or “Accountant”, and choose the pages and actions it can access.",
  "أوقف": "Disabled",
  "أوقف أسعار نهاية الأسبوع": "Turned off weekend pricing",
  "أوقف تسعير الموسم": "paused seasonal pricing",
  "أونلاين": "Online",
  "أي تغيير هنا يظهر فوراً في موقع الحجز": "Any change here appears instantly on the booking site",
  "أي سيارة تناسب رحلتك؟": "Which car suits your trip?",
  "أيام": "days",
  "أيام الأسبوع": "Weekdays",
  "أيام التأجير": "Rental days",
  "أيام نهاية الأسبوع في رحلتك تُحسب بأسعارها.": "Weekend days in your trip are charged at weekend prices.",
  "إيجار": "Rental",
  "إيجار المحل": "Shop rent",
  "إيجار نهاري": "Daytime rental",
  "إيرادات الإضافات": "Add-on revenue",
  "إيرادات التأجير": "Rental revenue",
  "إيطاليا": "Italy",
  "إيقاف تسعير الموسم": "Pause seasonal pricing",
  "باقة الكشتة": "Outing package",
  "باكستان": "Pakistan",
  "بِت ليلتك في الجبل،": "Stay the night,",
  "بدل": "instead of",
  "بدور": "as",
  "بدون إضافات": "No add-ons",
  "بدون تكلفة بترول.": "No fuel costs.",
  "بدون ما تشتري شيء.": "without buying anything.",
  "بركة الموز، ولاية نزوى": "Birkat Al Mouz, Wilayat of Nizwa",
  "بركة الموز، ولاية نزوى، سلطنة عُمان": "Birkat Al Mouz, Wilayat Nizwa, Sultanate of Oman",
  "بسعر": "at",
  "بطاقة بنكية": "Bank card",
  "بعد": "after",
  "بعد الاستلام": "After pickup",
  "بعد الخصومات": "After discounts",
  "بعد الموسم": "Off-season",
  "بعد خصم المصاريف الثابتة": "After fixed expenses",
  "بقي أقل من 3 أيام على موعد الاستلام. حسب سياسة الإيجار لا يُلغى الحجز ولا يُحوّل إلى رصيد.": "Less than 3 days remain until pickup. Under the rental policy, the booking can't be cancelled or converted to credit.",
  "بنسبة": "at",
  "بنغلاديش": "Bangladesh",
  "بوابة دفع آمنة · بيئة تجريبية": "Secure payment gateway · Test mode",
  "بياناتك": "Your details",
  "تابع حجزك وحوّله إلى رصيد": "Track your booking and convert it to credit",
  "تأجير": "Rental",
  "تأجير السيارات": "Car rental",
  "تأجير سيارات تسلا الكهربائية للصعود إلى الجبل الأخضر.": "Tesla electric car rental for the drive up Jebel Akhdar.",
  "تأخير": "Late",
  "تاريخ الاستلام": "Pickup date",
  "تاريخ الإصدار": "Issue date",
  "تاريخ الانتهاء": "Expiry date",
  "تاريخ الحجز": "Booking date",
  "تأكيد الإلغاء": "Confirm cancellation",
  "تأكيد التسليم": "Confirm handover",
  "تأكيد الحجز": "Confirm booking",
  "تبدأ من": "from",
  "تجربة الصلاحيات: سجّل الدخول كـ": "Test permissions: sign in as",
  "تحت الشحن": "Charging",
  "تحتاج تنظيف خفيف": "Needs a light clean",
  "تحتاج قرارك": "Needs your decision",
  "تحجز في دقيقتين": "Book in two minutes",
  "تحصيل المبلغ المتبقي": "Collect remaining balance",
  "تحويل الحجز": "Transfer booking",
  "تحويل الحجز #1031 إلى رصيد": "Convert booking #1031 to credit",
  "تحويل إلى رصيد": "Convert to credit",
  "تحويل حجز إلى رصيد": "Convert booking to credit",
  "تختار الموعد والسيارة وعدّة الشواء، ترفع البطاقة والرخصة، وتدفع العربون فقط.": "Choose the time, the car and the BBQ kit, upload your ID and licence, and pay just the deposit.",
  "تراجع": "Undo",
  "تستلم وتنطلق": "Pick up and go",
  "تسعير": "Pricing",
  "تسعير الموسم متوقف": "Seasonal pricing paused",
  "تسعير الموسم مفعّل": "Seasonal pricing active",
  "تسعير موسم)": "season pricing)",
  "تسلا كهربائية بالكامل · الجبل الأخضر": "All-electric Tesla · Jebel Akhdar",
  "تسلا موديل Y في الظلام": "Tesla Model Y in the dark",
  "تُسلَّم السيارة بشحن لا يقل عن 85%، ويمكن إعادتها بأي نسبة دون رسوم إضافية.": "The car is handed over with at least 85% charge, and can be returned at any level with no extra fees.",
  "تسليم": "Handover",
  "تسليم بعد 8 م": "Handover after 8 PM",
  "تسليم بعد 8 مساءً بـ": "Return after 8 PM at",
  "تسليم سيارة": "Hand over a car",
  "تسليم سيارة للزبون": "Hand over car to customer",
  "تسليم للزبائن اليوم": "Handovers today",
  "تسليم للزبون": "Hand over to customer",
  "تصدير التقارير": "Export reports",
  "تصدير Excel (CSV)": "Export Excel (CSV)",
  "تُعاد عدّة الشواء والطبخ نظيفة. فقدان أي قطعة يُحتسب بسعرها.": "The BBQ and cooking kits are returned clean. Any missing item is charged at its price.",
  "تعديل الدور": "Edit role",
  "تعديل الموعد": "Change time",
  "تعديل موعد الحجز": "Change booking time",
  "تعليق الصورة": "Photo caption",
  "تعيدها بأي شحن": "Return it at any charge level",
  "تغيّرت خططك؟": "Plans changed?",
  "تغيير الإطارات": "Tyre change",
  "تغيير الحالة": "Change status",
  "تفاصيل الحجز": "Booking details",
  "تفعيل بنقرة يرفع كل أسعار التأجير بنسبة الموسم المختار.": "One tap raises all rental prices by the selected season's rate.",
  "تفعيل حساب": "Activate account",
  "تفعيل موسم الصيف": "Activate summer season",
  "تقدير لطريق بركة الموز – سيح قطنة (70 كم ذهاباً وعودة) مع استهلاك الصعود.": "Estimate for the Birkat Al Mouz – Saiq road (70 km round trip) including the climb.",
  "تقرير": "Report",
  "تقويم الحجوزات": "Booking calendar",
  "تكفي لـ": "Enough for",
  "تكلفة البترول": "Fuel cost",
  "تم الاستلام:": "Received:",
  "تم التنفيذ": "Done",
  "تم الحجز، رحلة موفقة": "Booked. Enjoy the drive",
  "تم الدفع وإرسال العقد على واتساب": "Paid, and the contract was sent on WhatsApp",
  "تم إلغاء الحجز": "Booking cancelled",
  "تم إنشاء الحجز": "Booking created",
  "تم إنشاء الحساب": "Account created",
  "تم تأكيد حجزك": "Your booking is confirmed",
  "تم تحديث الدور": "Role updated",
  "تم تحويل الحجز إلى رصيد": "Booking converted to credit",
  "تم تسجيل الدخول كـ": "Signed in as",
  "تم تسجيل الصيانة": "Maintenance logged",
  "تم تسليم السيارة للزبون": "Car handed over to customer",
  "تم تعديل الحجز": "Booking updated",
  "تم تنزيل الملف": "File downloaded",
  "تم حذف الدور": "Role deleted",
  "تم حفظ الدور": "Role saved",
  "تم رفض الطلب": "Request declined",
  "تم رفع الأسعار 20% في موقع الحجز": "Prices raised 20% on the booking site",
  "تواصل معنا": "Contact us",
  "تواصل معنا على واتساب لمعرفة السبب.": "Message us on WhatsApp to find out why.",
  "توزيع إيرادات الإضافات": "Add-on revenue breakdown",
  "تونس": "Tunisia",
  "ث": "Tue",
  "ثانية من 0 إلى": "s, 0 to",
  "ثلاث سيارات، وعدّة شواء أو طبخ إن أردت.": "Three cars, plus a BBQ or cooking kit if you like.",
  "ثلاجة متنقلة وثلج": "Portable cooler and ice",
  "ج": "Fri",
  "جارٍ الآن": "In progress",
  "جاهزة للانطلاق": "Ready to go",
  "جهاز": "Device",
  "جوال": "Mobile",
  "ح": "Sun",
  "حاسوب": "Desktop",
  "حالة الأسطول الآن": "Fleet status now",
  "حتى الآن": "so far",
  "حجز آخر": "Another booking",
  "حجز جديد": "New booking",
  "حجز حضوري": "Walk-in booking",
  "حجز حضوري جديد": "New walk-in booking",
  "حجوزات": "Bookings",
  "حجوزات هذا الأسبوع": "Bookings this week",
  "حجوزاتي": "My bookings",
  "حدّد الموعد": "Set the time",
  "حدّد أيام نهاية الأسبوع": "Set weekend days",
  "حذف": "Delete",
  "حذف الدور": "Delete role",
  "حذف دور": "Delete role",
  "حساب الموظف": "Staff account",
  "حساب تجاري": "Business account",
  "حضوري": "Walk-in",
  "حفظ التعديل": "Save changes",
  "حفظ الدور": "Save role",
  "حوّل الحجز": "Transfer the booking",
  "خ": "Thu",
  "خارج المهلة": "Past deadline",
  "خارج المهلة)": "past the deadline)",
  "خارج مهلة الـ 72 ساعة. تجاوز السياسة متاح للمالك فقط وسيُسجَّل.": "Outside the 72-hour window. Policy override is available to the owner only and will be logged.",
  "خالد الريامي": "Khalid Al Riyami",
  "خدش جديد": "New scratch",
  "خدمة": "service",
  "خدمة جديدة": "New service",
  "خرجت": "Out",
  "خرجت بـ": "Left with",
  "خصم": "Discount",
  "خفيفة وموفّرة، مثالية لشخصين أو ثلاثة.": "Light and efficient, ideal for two or three people.",
  "دخول الموظفين": "Staff sign in",
  "دعوة الحجز": "Booking call-to-action",
  "دفع رباعي بمحركين في كل السيارات.": "Dual-motor all-wheel drive on every car.",
  "دفع كامل عند الحجز": "Full payment at booking",
  "دقائق": "minutes",
  "دور": "Role",
  "دور المالك يملك كل الصلاحيات دائماً ولا يمكن تقييده.": "The Owner role always has every permission and can't be restricted.",
  "دور جديد": "New role",
  "ديسمبر": "December",
  "ر": "R",
  "ر.ع": "OMR",
  "ر.ع (ما دفعته) إلى رصيد تستخدمه في أي حجز قادم. آخر موعد للطلب:": "OMR (what you paid) to credit you can use on any future booking. Request deadline:",
  "ر.ع إلى رصيد": "OMR to credit",
  "ر.ع إلى رصيدك.": "OMR to your credit.",
  "ر.ع لكل ساعة.": "OMR per hour.",
  "ر.ع للزبون": "OMR to the customer",
  "ر.ع لو اشتريتها": "OMR if bought",
  "ر.ع نقداً أو بالبطاقة عند الاستلام.": "OMR in cash or by card at pickup.",
  "ر.ع.": "OMR.",
  "ر.ع)": "OMR)",
  "راتب الموظف": "Staff salary",
  "رؤية مبالغ الحجوزات": "See booking amounts",
  "رجوع": "Back",
  "رحلة يوم للجبل والعودة مساءً. التسليم بعد 8 م يضاف عليه": "A day trip up the mountain, back by evening. Returns after 8 PM add",
  "رحلتك مع مسار": "Your trip with Masar",
  "رخصة القيادة": "Driving licence",
  "رخصة:": "Licence:",
  "رسوم التأخير بعد 8 م (لكل ساعة)": "Late fee after 8 PM (per hour)",
  "رصيد": "Credit",
  "رصيدك الحالي": "Your current credit",
  "رصيدك يغطي المبلغ المطلوب الآن": "Your credit covers the amount due now",
  "رفض": "Decline",
  "رُفض طلب التحويل": "Conversion request declined",
  "رفض طلب تحويل الحجز": "Reject booking conversion request",
  "رقم": "No.",
  "رقم البطاقة": "Card number",
  "رقم الحجز": "Booking number",
  "رقم الرخصة": "Licence number",
  "رقم الفاتورة": "Invoice number",
  "رقم الهاتف": "Phone number",
  "رقم الهاتف (واتساب)": "Phone number (WhatsApp)",
  "رقم رخصة القيادة": "Driving licence number",
  "رقم واتساب": "WhatsApp number",
  "رمادي": "Grey",
  "رمز الدولة": "Country code",
  "روسيا": "Russia",
  "زبائن": "Customers",
  "زر الباقة": "Package button",
  "زر البدء": "Start button",
  "س": "h",
  "س)": "h)",
  "ساعات العمل": "Working hours",
  "ساعة": "hour",
  "ساعة على الاستلام · آخر موعد للطلب": "hours to pickup · request deadline",
  "ساعة: يضاف": "hours: add",
  "ساعة)": "hours)",
  "سالم الحارثي": "Salem Al Harthi",
  "سبب الإلغاء": "Cancellation reason",
  "سبتمبر": "September",
  "سبتمبر – 3 أكتوبر": "September – 3 October",
  "ستظهر هنا تفاصيل الحجز وحالته ورصيدك.": "Your booking details, status and credit will appear here.",
  "سجّل": "Log",
  "سجل الأنشطة": "Activity log",
  "سعة 45 لتر مع أكياس ثلج": "45-litre capacity with ice packs",
  "سعة البطارية)": "battery capacity)",
  "سعر الوحدة": "Unit price",
  "سعر خاص لكل سيارة في الأيام المحددة، وتسعير الموسم يُضاف فوقه.": "Each car has its own price on the selected days. Season pricing is added on top.",
  "سعيد الغافري": "Saeed Al Ghafri",
  "سلّم": "handed over",
  "سلّم السيارة Model Y (4822 AM) للزبون سالم الحارثي، حجز #1041 — العداد 22,748 كم، البطارية 94%": "Handed over Model Y (4822 AM) to customer Salem Al Harthi, booking #1041 — odometer 22,748 km, battery 94%",
  "سمح بالعربون لـ": "allowed a deposit for",
  "سنوي": "Annual",
  "سيارات": "cars",
  "سيارات جاهزة الآن": "Cars ready now",
  "سيارات متاحة": "cars available",
  "سيارة أخرى": "Another car",
  "سيارة واحدة متاحة": "One car available",
  "سيارتان متاحتان": "2 cars available",
  "سياسة الإيجار: لا إلغاء. التحويل إلى رصيد قبل 72 ساعة على الأقل من الاستلام.": "Rental policy: no cancellations. Conversion to credit at least 72 hours before pickup.",
  "سياسة الإيجار: لا يمكن إلغاء الحجز. يمكن تحويله إلى رصيد بقيمة المدفوع عند الطلب قبل 72 ساعة على الأقل من موعد الاستلام.": "Rental policy: bookings can't be cancelled. They can be converted to credit for the amount paid if requested at least 72 hours before pickup.",
  "سيح قطنة": "Saiq",
  "سيُخصَّص:": "Will be assigned:",
  "سيدان": "Sedan",
  "سيصلك إشعار على واتساب عند اعتماده.": "You'll get a WhatsApp notification once it's approved.",
  "شراؤها": "buying",
  "شروط الإيجار": "Rental terms",
  "شريط الأرقام": "Key figures",
  "شكراً لاختياركم مسار.": "Thank you for choosing Masar.",
  "شكراً لك يا سالم.": "Thank you, Salem.",
  "شهري": "Monthly",
  "شواية فحم، فحم، أدوات وقفازات": "Charcoal grill, charcoal, tools and gloves",
  "ص": "AM",
  "ص – 8 م": "AM – 8 PM",
  "ص – 8:00 م": "AM – 8:00 PM",
  "صافي الربح التقديري": "Estimated net profit",
  "صباح الخير،": "Good morning,",
  "صباحاً": "AM",
  "صدّر تقرير": "Export report",
  "صعدت بهدوء بلا صوت محرك، والبطارية ما زالت 78%. تكلفة البترول: صفر.": "It climbed quietly with no engine noise, and the battery is still at 78%. Fuel cost: zero.",
  "صفحات الإدارة": "Admin pages",
  "صفحات العمليات": "Operations pages",
  "صفحتان": "2 pages",
  "صلاحية": "Permission",
  "صلاحية)": "permissions)",
  "صورة البطاقة الشخصية / جواز السفر": "ID card / passport photo",
  "صورة رخصة القيادة": "Driving licence photo",
  "صيانة": "Maintenance",
  "ضمن المهلة": "Within deadline",
  "طابقت الاسم والصورة والرقم المدني مع البطاقة والرخصة الأصليتين": "I matched the name, photo and civil ID against the original ID card and licence",
  "طابقت الاسم والصورة ورقم الرخصة مع المستندات الأصلية": "I matched the name, photo and licence number against the original documents",
  "طاولة قابلة للطي و 4 كراسي": "Folding table and 4 chairs",
  "طاولة وكراسي تخييم": "Camping table and chairs",
  "طباعة": "Print",
  "طباعة / حفظ": "Print / save",
  "طريق جبلي متعرج كما يراه السائق": "A winding mountain road from the driver's seat",
  "طلب": "requested",
  "طلب الزبون": "Customer request",
  "طلب تحويل الحجز": "Booking conversion request",
  "طلب تحويل من الزبون بانتظار الاعتماد": "Customer transfer request awaiting approval",
  "طلبات التحويل إلى رصيد": "Credit conversion requests",
  "طلبات بانتظار الاعتماد": "Requests awaiting approval",
  "طلبات مرفوضة": "Rejected requests",
  "طلبات معتمدة": "Approved requests",
  "طلبك قيد المراجعة": "Your request is under review",
  "طلعات": "Trips",
  "ظاهر في الموقع": "Visible on site",
  "ظهر القسم في الموقع": "Section is now visible",
  "عائشة الهنائية": "Aisha Al Hinai",
  "عاد النص الأصلي": "Original text restored",
  "عادت الأسعار إلى التسعير العادي": "Prices are back to standard pricing",
  "عبر": "via",
  "عداد · بطارية · فحص": "Odometer · battery · inspection",
  "عداد العودة": "Return odometer",
  "عدّة الشواء": "BBQ kit",
  "عدّة الشواء في الصندوق": "BBQ kit in the boot",
  "عدّة الطبخ": "Cooking kit",
  "عدد الأيام": "Number of days",
  "عدد الحجوزات": "Number of bookings",
  "عدّل": "Edited",
  "عدّل سعر": "Edit price",
  "عدّل موعد الحجز رقم": "rescheduled booking no.",
  "عدّل نص": "edited the text",
  "عدم الحضور": "No-show",
  "عربون": "Deposit",
  "عطل في السيارة": "Vehicle fault",
  "عقد الإيجار وشروطه. موقعنا: بركة الموز قبل نقطة التفتيش.": "The rental contract and its terms. Our location: Birkat Al Mouz, before the checkpoint.",
  "عقد الإيجار PDF على واتساب بكل التفاصيل والشروط. لا أوراق ولا انتظار.": "PDF rental contract on WhatsApp with all the details and terms. No paperwork, no waiting.",
  "عقد-إيجار": "rental-contract",
  "عقد-إيجار-M1049.": "rental-contract-M1049.",
  "عُمان": "Oman",
  "عمر الكندي": "Omar Al Kindi",
  "عن الفترة السابقة": "vs previous period",
  "عند": "at",
  "عند التسليم": "At handover",
  "عند الحجز والباقي عند الاستلام": "at booking and the rest at pickup",
  "عند الخروج:": "At departure:",
  "غيّر حالة": "changed status of",
  "غيّر دور": "Changed role of",
  "غير قابل للاسترداد": "Non-refundable",
  "فاتورة": "Invoice",
  "فاتورة الكهرباء": "Electricity bill",
  "فاتورة الكهرباء الشهرية (ر.ع)": "Monthly electricity bill (OMR)",
  "فبراير": "February",
  "فتح": "Open",
  "فتح وإغلاق الحجز · أكتوبر": "Open and close booking · October",
  "فحص دوري + إطارات": "Scheduled service + tyres",
  "فحص واستلام الإضافات": "Inspect and check in add-ons",
  "فرنسا": "France",
  "فعّال الآن": "Active now",
  "فعّل": "Enable",
  "فعّل أسعار نهاية الأسبوع": "Turned on weekend pricing",
  "فعّل تسعير موسم الصيف": "Activate summer season pricing",
  "في الفترة النهارية، كل ساعة بعد 8:00 مساءً تُحسب": "During the daytime period, each hour after 8:00 PM is charged at",
  "في المحل": "in store",
  "قابل للتحويل إلى رصيد": "Convertible to credit",
  "قابل للتحويل)، أو": "convertible), or",
  "قبل نقطة تفتيش الجبل الأخضر": "Before the Jebel Akhdar checkpoint",
  "قبول العربون لهذه السيارة": "Accept a deposit for this car",
  "قراءة العداد (كم)": "Odometer reading (km)",
  "قراءة العداد الآن (كم)": "Odometer reading now (km)",
  "قرأت شروط الإيجار وأوافق عليها": "I have read and agree to the rental terms",
  "قسم": "section",
  "قصة الرحلة": "Trip story",
  "قطر": "Qatar",
  "قيد الصيانة": "Under maintenance",
  "قيمة الحجوزات": "Booking value",
  "قيمة الرصيد": "Credit value",
  "كاملاً الآن": "in full now",
  "كاملة ونظيفة": "Full and clean",
  "كشتة كاملة،": "A full outing,",
  "كل الأيام الآن بنفس السعر": "Every day now has the same price",
  "كل الحجوزات القادمة": "All upcoming bookings",
  "كل السيارات كهربائية بالكامل، والشحن مشمول في السعر.": "All cars are fully electric, and charging is included in the price.",
  "كل الصلاحيات": "All permissions",
  "كل النصوص أصلية": "All text is original",
  "كلها فعّالة": "All active",
  "كم": "km",
  "كم بشحنة واحدة": "km on one charge",
  "كم هذا الشهر": "km this month",
  "كم،": "km,",
  "كم، البطارية": "km, battery",
  "كم)": "km)",
  "كوب قهوة على صخور الجبل وقت الغروب": "A cup of coffee on the mountain rocks at sunset",
  "كود الخصم": "Discount code",
  "كيف تحجز": "How to book",
  "لـ": "for",
  "لا إلغاء · تحويل إلى رصيد": "No cancellation · convert to credit",
  "لا توجد أرصدة": "No credit",
  "لا توجد إضافات في هذا الحجز": "No extras on this booking",
  "لا توجد أنشطة": "No activity",
  "لا توجد بيانات في هذه الفترة": "No data for this period",
  "لا توجد تسليمات متبقية اليوم": "No handovers left today",
  "لا توجد حجوزات مؤكدة": "No confirmed bookings",
  "لا توجد سيارات متاحة في هذا الموعد": "No cars available at this time",
  "لا توجد سيارات مع الزبائن": "No cars with customers",
  "لا توجد سيارات مع الزبائن الآن": "No cars with customers right now",
  "لا توجد سيارة متاحة بهذا الموعد": "No car available at this time",
  "لا توجد صفحات مسموحة لهذا الحساب. تواصل مع المالك.": "No pages are permitted for this account. Contact the owner.",
  "لا توجد طلبات معلقة": "No pending requests",
  "لا حاجة لبطاقة. اضغط تأكيد الحجز.": "No card needed. Tap Confirm booking.",
  "لا خدوش جديدة": "No new scratches",
  "لا شيء عليك عند الاستلام، فقط المطابقة.": "Nothing to pay at pickup, just verification.",
  "لا شيء معلق": "Nothing pending",
  "لا يتوفر عربون لهذه السيارة. تدفع": "No deposit option for this car. You pay",
  "لا يُلغى الحجز، لكن يمكنك تحويله إلى رصيد من «حجوزاتي» حتى": "Bookings can't be cancelled, but you can convert yours to credit from My bookings until",
  "لا يمكن إلغاء الحجز، لكن يمكنك تحويله إلى رصيد إذا طلبت ذلك قبل 3 أيام على الأقل من موعد الاستلام.": "Bookings can't be cancelled, but you can convert yours to credit if you request it at least 3 days before pickup.",
  "لا يمكن إلغاء الحجز. يمكنك تحويله إلى رصيد بقيمة ما دفعته إذا طلبت ذلك قبل 3 أيام (72 ساعة) على الأقل من موعد الاستلام، من صفحة «حجوزاتي». يُستخدم الرصيد في أي حجز قادم. بعد ذلك يصبح الحجز غير قابل للاسترداد.": "Bookings cannot be cancelled. You can convert yours to credit for the amount you paid if you request it at least 3 days (72 hours) before pickup, from the “My bookings” page. Credit can be used on any future booking. After that, the booking is non-refundable.",
  "لا يمكن تحويله إلى رصيد.": "Cannot be converted to credit.",
  "لا يمكن حذف دور مسند لموظفين": "A role assigned to staff can't be deleted",
  "لا يوجد": "None",
  "لبنان": "Lebanon",
  "لجبل": "to Jebel",
  "لديك رصيد": "You have credit of",
  "لعشاق القيادة": "For driving enthusiasts",
  "للتجربة: الحجز": "Demo: booking",
  "للحالات الاستثنائية مثل عدم الحضور. الزبون لا يحصل على رصيد.": "For exceptional cases such as a no-show. The customer gets no credit.",
  "للزبائن الحاضرين في المحل": "For walk-in customers",
  "للزبون": "to customer",
  "للزوجين": "For couples",
  "للعائلة": "For families",
  "للفريق": "For the team",
  "للمبيت في الجبل. التسليم في نفس وقت الاستلام من اليوم التالي.": "For an overnight stay on the mountain. Return is at the same time as pickup the next day.",
  "لم تختر السيارة بعد": "You haven't chosen a car yet",
  "لم نجد حجزاً بهذا الرقم والهاتف. تأكد من البيانات.": "We couldn't find a booking with this number and phone. Check your details.",
  "لم يسجّل دخول بعد": "Not logged in yet",
  "لوحة المالك": "Owner dashboard",
  "ليلى التوبية": "Laila Al Toubi",
  "م": "PM",
  "ما دفعه الزبون) إلى رصيده على الرقم": "what the customer paid) to their credit on number",
  "مؤجرة": "Rented",
  "مارس": "March",
  "مؤكد": "Confirmed",
  "مايو": "May",
  "متاحة": "Available",
  "متاحة الآن": "Available now",
  "متاحة في الموقع": "Available on site",
  "متأخر": "Late",
  "متأخر)": "late)",
  "متبقٍ": "remaining",
  "متبقي": "remaining",
  "متسخة": "Dirty",
  "متسخة (رسوم تنظيف)": "Dirty (cleaning fee)",
  "متى تريد الانطلاق؟": "When do you want to set off?",
  "مثال: تعويض عن تأخير التسليم": "Example: compensation for a late handover",
  "مثال: خيمة تخييم": "Example: camping tent",
  "مثال: سالم بن خلفان الحارثي": "e.g. Salem bin Khalfan Al Harthi",
  "مثال: محاسب": "e.g. Accountant",
  "محتوى الموقع": "Site content",
  "محجوزة": "Booked",
  "محجوزة بالكامل": "Fully booked",
  "محمد العبري": "Mohammed Al Abri",
  "محوّل إلى أرصدة": "Converted to credit",
  "محوّل إلى رصيد": "Converted to credit",
  "مخطط السيارة من الأعلى، اضغط لتحديد خدش": "Top view of the car, tap to mark a scratch",
  "مخفي": "Hidden",
  "مدة الاستلام: مطابقة الهوية وتسجيل العداد، ثم تنطلق.": "Pickup time: ID check and odometer reading, then you're off.",
  "مدفوع بالكامل": "Paid in full",
  "مدفوع بالكامل أونلاين": "Paid in full online",
  "مدفوعة بالكامل": "Paid in full",
  "مدى بشحنة واحدة، يكفي الطلعة والعودة أكثر من مرة.": "Range on a single charge, enough for the climb and back more than once.",
  "مراحل الحجز": "Booking stages",
  "مرحباً": "Hello",
  "مرفوض": "Declined",
  "مرفوعة": "Uploaded",
  "مساءً": "PM",
  "مساحة واسعة وصندوق كبير يتسع لعدّة الكشتة.": "Spacious, with a large boot that fits your camping kit.",
  "مسار": "Masar",
  "مسار | تأجير سيارات تسلا الكهربائية – الجبل الأخضر": "Masar | Tesla electric car rental – Jebel Akhdar",
  "مسار | تطبيق الموظف": "Masar | Staff app",
  "مسار | لوحة المالك": "Masar | Owner dashboard",
  "مسار لتأجير السيارات": "Masar Car Rental",
  "مستحق عند الاستلام": "Due at pickup",
  "مستندات غير مطابقة": "Documents don't match",
  "مشترك": "shared",
  "مشرف الفرع": "Branch supervisor",
  "مصر": "Egypt",
  "مطابقة · تحصيل · عداد وبطارية": "Verify · collect · odometer and battery",
  "مطابقة الهوية والرخصة": "ID and licence verification",
  "مطابقة الهوية، تسجيل العداد والبطارية، وعدّتك جاهزة في الصندوق. دقائق وأنت على الطريق.": "ID check, odometer and battery logged, and your kit ready in the boot. Minutes later you're on the road.",
  "مطابقة بيانات الزبون": "Verify customer details",
  "مطبق": "Applied",
  "مع الزبون": "With customer",
  "معاينة الموقع": "Site preview",
  "معاينة رسالة واتساب": "WhatsApp message preview",
  "معتمد": "Approved",
  "معتمد، من 9 أشهر إلى 4 سنوات": "Approved, from 9 months to 4 years",
  "معدّل": "Edited",
  "مغلق للحجز": "Closed for booking",
  "مقاعد": "seats",
  "مقعد أطفال": "Child seat",
  "مقفل": "Locked",
  "مكتمل": "Completed",
  "ملاحظات": "Notes",
  "ملاحظة (تظهر للمالك في سجل الأنشطة)": "Note (visible to the owner in the activity log)",
  "ملخص الحجز": "Booking summary",
  "ملغاة أو محوّلة": "Cancelled or transferred",
  "ملغي": "Cancelled",
  "من": "from",
  "من 8 ص)": "from 8 AM)",
  "من الإجمالي": "of total",
  "من الإيراد إلى الصافي": "From revenue to net",
  "من أيام نهاية الأسبوع، وتنطبق عليه أسعارها.": "is a weekend day, so weekend prices apply.",
  "من جوالك.": "from your phone.",
  "من حجز": "from booking",
  "من رصيدك": "from your credit",
  "من رصيدك)": "from your credit)",
  "من يدخل النظام، وماذا يرى، وماذا فعل": "Who signs in, what they see, and what they did",
  "منتهٍ": "Ended",
  "منذ بداية الشهر": "Month to date",
  "منها": "of which",
  "موسم الصيف في الجبل": "Summer season on the mountain",
  "موظف": "Staff",
  "موظف استقبال": "Receptionist",
  "موظفين": "staff",
  "موعد العودة": "Return time",
  "موقد غاز، قدر، أواني لـ 6 أشخاص": "Gas stove, pot, utensils for 6 people",
  "موقع الحجز": "Booking location",
  "موقعنا: بركة الموز قبل نقطة التفتيش.": "Find us in Birkat Al Mouz, before the checkpoint.",
  "موقوف": "Suspended",
  "موقوفة. كل الأيام بنفس السعر.": "Off. Every day has the same price.",
  "ن": "M",
  "نبذة": "About",
  "نجهزها في صندوق السيارة قبل وصولك، وتعيدها معها. لا شراء، لا تخزين، لا تحميل.": "We set it up in the boot before you arrive, and you return it with the car. No buying, no storing, no loading.",
  "نحوّل": "We convert",
  "نراك في الطلعة الجاية.": "See you on the next trip.",
  "نسبة الشحن": "Charge level",
  "نسبة الشحن (خرجت بـ": "Charge level (left at",
  "نسبة العربون": "Deposit percentage",
  "نسجّل المسافة والطاقة تلقائياً، وتمشي. لا محطة بنزين ولا فاتورة وقود.": "We log the distance and energy automatically, and you're on your way. No petrol station, no fuel bill.",
  "نشط": "Active",
  "نص المحطة 1": "Stop 1 text",
  "نص المحطة 2": "Stop 2 text",
  "نص المحطة 3": "Stop 3 text",
  "نص المحطة 4": "Stop 4 text",
  "نص المحطة 5": "Stop 5 text",
  "نصوص معدّلة": "edited texts",
  "نطابقها مع البطاقة عند الاستلام. صور المستندات تُحفظ بشكل آمن.": "We match it with your ID card at pickup. Document photos are stored securely.",
  "نظيفة": "Clean",
  "نقداً": "Cash",
  "نهاري": "Daytime",
  "نهاري · نهاية الأسبوع": "Daytime · weekend",
  "نهاري 8 ص – 8 م": "Daytime 8 AM – 8 PM",
  "نهاري أو يوم كامل، ووقت الاستلام الذي يناسبك.": "Daytime or full day, at the pickup time that suits you.",
  "نهاية الأسبوع": "Weekend",
  "نورة السيابية": "Noura Al Siyabi",
  "نوع الفترة": "Period type",
  "نوفمبر": "November",
  "هاتف الزبون": "Customer phone",
  "هذا الأسبوع": "This week",
  "هذا الشهر": "This month",
  "هذه السيارة تتطلب الدفع الكامل الآن": "This car now requires full payment",
  "هذه السيارة تتطلب الدفع الكامل عند الحجز": "This car requires full payment when booking",
  "هكذا تمشي الرحلة من أول نقرة حتى تعيد المفتاح.": "Here's how the trip goes, from the first tap to handing back the key.",
  "هلال المعمري": "Hilal Al Maamari",
  "و": "and ",
  "واتساب:": "WhatsApp:",
  "وافق على الشروط للمتابعة": "Accept the terms to continue",
  "والسيارة مشحونة.": "wake up fully charged.",
  "والهاتف": "and phone",
  "وتسجيله في السجل": "and record it in the log",
  "وتنتظرك عند بداية الطريق.": "and waits for you at the start of the road.",
  "وقت الاستلام": "Pickup time",
  "وقت التسليم": "Return time",
  "يجب ألا يقل عمر السائق عن 21 سنة، ورخصة سارية لمدة سنة على الأقل.": "Drivers must be at least 21 years old, with a licence valid for at least one year.",
  "يُحفظ كل تعديل فوراً ويظهر للزوار مباشرة. اترك الحقل فارغاً لاستخدام النص الأصلي.": "Every edit saves instantly and goes live for visitors. Leave a field empty to use the original text.",
  "يُخصم": "Deducted",
  "يُخصم من الإجمالي، والباقي يُدفع عند الاستلام.": "Deducted from the total, the rest is paid at pickup.",
  "يدفع الزبون": "Customer pays",
  "يرى الموظف فقط الصفحات والإجراءات المفعّلة في دوره. عدّلها من تبويب «الأدوار والصلاحيات».": "Staff only see the pages and actions enabled in their role. Edit them from the “Roles and permissions” tab.",
  "يُسجَّل وضع السيارة عند الاستلام والتسليم، وأي خدوش جديدة تُقيَّم حسب جدول الأضرار.": "The car's condition is recorded at pickup and return, and any new scratches are assessed using the damage schedule.",
  "يصلك العقد على واتساب، والسيارة جاهزة عند وصولك.": "Your contract arrives on WhatsApp, and the car is ready when you arrive.",
  "يُلغى الحجز وتتحرر السيارة، ويُضاف": "The booking is cancelled and the car released, adding",
  "يمكنك تحويل الحجز إلى رصيد": "You can convert the booking to credit",
  "يُمنع التدخين داخل السيارة والقيادة خارج الطرق المعبدة.": "No smoking inside the car and no off-road driving.",
  "يناير": "January",
  "يوسف الشكيلي": "Yousef Al Shukaili",
  "يوليو": "July",
  "يوم": "day",
  "يوم كامل": "Full day",
  "يوم كامل · نهاية الأسبوع": "Full day · weekend",
  "يوم كامل لمدة 24 ساعة: استلمها اليوم وأعدها غداً في نفس الوقت.": "Full day for 24 hours: pick it up today and return it tomorrow at the same time.",
  "يوم و": "day and",
  "يوم واحد": "One day",
  "يومان": "2 days",
  "يومك في الجبل،": "Your day on the mountain,",
  "يومي": "Daily",
  "يومياً 7:30 ص – 11:00 م": "Daily 7:30 AM – 11:00 PM",
  "يونيو": "June",
  "يونيو – سبتمبر": "June – September",
  "SUV رياضية": "Sport SUV",
  "SUV عائلية": "Family SUV",
};
